package dev.mmartos.advent.models

data class DayDetails(
    val day: Int,
    val title: String,
)